/**
 * Entry point. Registers <scgb-search> as a custom element.
 *
 * Two modes:
 *   <scgb-search mode="modal">    — autocomplete dropdown inside the Bootstrap modal
 *   <scgb-search mode="results">  — full-page results, drop-in for the WP search.php body
 *
 * Both use the same Lit element; mode determines layout and behaviour.
 */

import { ScgbSearchElement } from "./element.js";

if (!customElements.get("scgb-search")) {
  customElements.define("scgb-search", ScgbSearchElement);
}

export { ScgbSearchElement };
